module.exports = __webpack_public_path__ + "pc/img/small_logo.7eeb3082.png";